export const GoogleConsts = {
  SCOPE: 'https://www.googleapis.com/auth/drive.readonly',
  API_URL: 'https://apis.google.com/js/api.js',
  GSI_CLIENT_URL: 'https://accounts.google.com/gsi/client',
  CLIENT_ID: process.env.GDRIVE_CLIENT_ID,
  DEVELOPER_KEY: process.env.GDRIVE_DEVELOPER_KEY,
};
